import SellOrderConsult from './SellOrderConsult';

export default SellOrderConsult;